import * as React from "react";
import { isEmpty as _isEmpty, isNull as _isNull } from "lodash";
import { default as AppUtils, LOADING_STATE } from "../utils/AppUtils";
import { IPdfTemplates } from "../models/PdfTemplatesModels";
import ITreatmentPlanTemplateResponseObj from "../models/ITreatmentPlanTemplateResponse";
import CommonPrescriptionPdf from "./templates/CommonPrescriptionPdf";
import IDoctorSpeciality from "../models/IDoctorSpeciality";
import IDoctorProfile from "../models/IDoctorProfile";

export interface TreatmentPlanReviewPdfProps {
    previewMode: boolean
    templateData: ITreatmentPlanTemplateResponseObj,
    toggleModal: (flag: boolean) => void,
    pdfTemplates: IPdfTemplates,
    staticSpecialistData: IDoctorSpeciality[],
    handleSaveClick?: () => void,
    doctorProfile: IDoctorProfile
}

const TreatmentPlanReviewPdf: React.FC<TreatmentPlanReviewPdfProps> = (props) => {

    const [pdfGenerationStatus, setPdfGenerationStatus] = React.useState<LOADING_STATE>(LOADING_STATE.LOADING);

    React.useEffect(() => {
        // On Mount
        AppUtils.closeChatContainer()
        // Unmount
        return () => {
            window.onbeforeunload = null;
        }
    }, [])

    const preventModalClose = (event: any) => {
        event.stopPropagation();
    }

    const closeModal = () => {
        props.toggleModal(false);
    }

    const handleSaveClick = () => {
        props.handleSaveClick()
    }

    const generatePDF = () => {
        setPdfGenerationStatus(LOADING_STATE.LOADED);
    }

    return (
        <div className={"review-prescription-container"} onClick={preventModalClose}>
            <div className={"cancel-modal"} onClick={closeModal}>x</div>
            <div style={{ overflow: "hidden" }}>
                {/*Prescription PDF template*/}
                {!_isEmpty(props.templateData) &&
                    <CommonPrescriptionPdf
                        pdfTemplates={props.pdfTemplates}
                        isPhysioConsultation={false}
                        isTreatmentPlan={true}
                        treatmentPlanData={{
                            templateData: props.templateData,
                            doctorProfile: props.doctorProfile,
                            staticSpecialistData: props.staticSpecialistData
                        }}
                        hideHeaderFooter={false}
                        renderHandler={() => generatePDF()}
                    />
                }
            </div>
            {
                pdfGenerationStatus === LOADING_STATE.LOADED &&
                <div className={"action-icons"}>
                    {/* <div className={"pdf-failed animated fadeInRight edit-info"}>
                        <span>
                            <span className="glyphicon glyphicon-info-sign" />
                            {AppMessages.EDIT_PRESCRIPTION_CONFIRM_DIALOG}
                        </span>
                    </div> */}
                    <div className={"continue-editing"}>
                        <input className={"cf-btn-rounded-bordered animated fadeInRight"}
                            type="button"
                            value={props.previewMode ? "Close" : "Edit"}
                            onClick={() => {
                                props.toggleModal(false)
                            }}
                        />
                    </div>
                    {!props.previewMode &&
                        <div className={"send-prescription"}>
                            <input className={"cf-btn-gradient animated fadeInRight"}
                                type="button"
                                value={"Save"}
                                onClick={() => {
                                    handleSaveClick()
                                }} />
                        </div>
                    }
                </div>
            }
        </div>
    )
}

export default TreatmentPlanReviewPdf